module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/5/2-ac044d50adc7538d443ccdf2ef12ce4f.jpg";